import dayjs from 'dayjs';
import { DashboardListItemViewFragment } from 'generated/graphql';
import { DashboardListItem } from 'v2/core/entities/dashboard';
import { mapFromEdgeScope } from 'v2/core/repository/edge-server/analysis/fromEdgeAnalysis';

export const mapToDashboardListItem = (
  dashboard: DashboardListItemViewFragment,
): DashboardListItem => ({
  ...dashboard,
  title: dashboard.title,
  scope: mapFromEdgeScope(dashboard.scope),
  recency: dayjs.unix(dashboard.recency),
  createdBy: {
    ...dashboard.createdBy,
    firstName: dashboard.createdBy.firstName,
    lastName: dashboard.createdBy.lastName,
  },
  analysisIDs: dashboard.analysisIDs,
  shortMetadata: dashboard.shortMetadata,
});

export const mapToDashboardListItems = (
  dashboards: DashboardListItemViewFragment[],
): DashboardListItem[] => {
  return dashboards.map((dashboard) => mapToDashboardListItem(dashboard));
};
